function WriteTableRow(col, x, y, width, height, paper, TDdata, isDark, isLoadRect) {
	if (isLoadRect) {
		paper.rect(x, y, width, height).attr({
			fill: isDark ? "#1C2137" : "#FDFAF6",
			"font-weight": "bold",
			stroke: isDark ? "#ffffff" : "#04112F",
			"stroke-width": "0.25"
		});
	}
		
	const text = paper
		.text(x + width / 2, y + height / 2, TDdata)
		.attr({
			fill: col
		});
	x = x + width;
	
	return text;
}

function WriteAnnTableRow(col, x, y, width, height, paper, TDdata, isDark, isLoadRect) {

	if (isLoadRect) {
		paper.rect(x, y, width, height).attr({
			fill: isDark ? "#1C2137" : "#FDFAF6",
			"font-weight": "bold",
			stroke: isDark ? "#ffffff" : "#04112F",
			"stroke-width": "0.25"
		});
	}

	const cir = paper.circle(x + width / 2, y + height / 2, 5).attr({ 
		fill: col,
		"stroke-width": '0',
	});

	return cir;
}

function WriteTextAndStatus(col, x, y, width, height, paper, TDdata, isDark) {
	const TD = TDdata.split(",");
	const nodeList = []
	for (let j = 0; j < TD.length; j++) {
		const rect = paper.rect(x, y, width, height).attr({
			fill: isDark ? "#1C2137" : "#FDFAF6",
			"font-weight": "bold",
			stroke: isDark ? "#ffffff" : "#04112F",
			"stroke-width": "0.25"
		});
		nodeList.push(rect)
		if (TD[j] == '') {
			const cir = paper.circle(x + width / 2, y + height / 2, 5).attr({ 
				fill: col,
				"stroke-width": '0',
			});
			nodeList.push(cir)
		} else {
			const text = paper
				.text(x + 10, y + height / 2, TD[j])
				.attr({
					fill: '#668cf6',
					"text-anchor": "start"
				});
			const cir = paper.circle(x + width - 10, y + height / 2, 5).attr({ 
				fill: col,
				"stroke-width": '0',
			});
			nodeList.push(text, cir)
		}
	}
	return nodeList
}

export {
	WriteTableRow,
	WriteAnnTableRow,
	WriteTextAndStatus
}